interface DeviceOnDiagnostics {
  model: string;
  serialNumber: string;
  isWarrantyExpired: boolean;
}

function transliterateModel(model: string) {
  const transliterations: Record<string, string> = {
    тд: 'TD',
    тдбле: 'TD-BLE',
  };
  return model
    .split('-')
    .map((part) => transliterations[part] || part)
    .join('-')
    .toUpperCase();
}

export function parseHtmlTable(htmlString: string | undefined): DeviceOnDiagnostics[] {
  if (!htmlString) return [{ model: '', serialNumber: '', isWarrantyExpired: true }];
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString.trim(), 'text/html');
  const rows = doc.querySelectorAll('table.in-ckeditor tbody tr');
  const resultArray: DeviceOnDiagnostics[] = [];

  rows.forEach((row) => {
    const cells = row.querySelectorAll('td');
    if (cells.length >= 2) {
      let model = cells[0].textContent ? cells[0].textContent.trim() : '';
      const serialNumber = cells[1].textContent ? cells[1].textContent.trim() : '';
      const isWarrantyExpired =
        cells.length > 3 && (cells[3].textContent || '').includes('срок гарантии');
      model = transliterateModel(model);
      resultArray.push({ model, serialNumber, isWarrantyExpired });
    }
  });

  return resultArray;
}
